import React from 'react'

export const Spacer = ({grow=1}) => {
  return <div style={{flexGrow:grow}} />
}